//Master Data
const masterTableFieldsGrip = [
    {title: "Ref Id",
        is_searchable: false,
        class_name: 'w-110p',
        field: {
            name: "id"
        },
        fetch_key: "id"
    },
    {title: "School",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "school_id"
        },
        accessRoleIds: [2, 7],
        option_label: "school_name",
        option_val: "id",
        fetch_key: "school_name"
    },
    {title: "Branch",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "branch_id"
        },
        accessRoleIds: [2, 7],
        option_label: "branch_name",
        option_val: "id",
        fetch_key: "branch_name"
    },
    {title: "GLOSCO Sessions Count",
        is_searchable: true,
        field: {
            type: "select",
            name: "glosco_session_count"
        },
        option_label: "session",
        option_val: "id",
        fetch_key: "glosco_session_count"
    },
    {title: "GRIP Sessions Count",
        is_searchable: true,
        field: {
            type: "select",
            name: "grip_session_count"
        },
        option_label: "session",
        option_val: "id",
        fetch_key: "grip_session_count"
    }
];

const masterTableFieldsConf = [
    {title: "Session",
        is_searchable: true,
        class_name: 'w-auto',
        field: {
            type: "select",
            name: "session_id"
        },
        option_label: "label",
        option_val: "id",
        fetch_key: "session"
    },
    {title: "School",
        is_searchable: true,
        class_name: 'w-auto',
        field: {
            type: "select",
            name: "school_id"
        },
        accessRoleIds: [2, 7],
        option_label: "school_name",
        option_val: "id",
        fetch_key: "school_name"
    },
    {title: "Status",
        is_searchable: true,
        class_name: 'w-110p',
        field: {
            type: "select",
            name: "active_status_id"
        },
        option_label: "status",
        option_val: "id",
        fetch_key: "active_status_id"
    }
];

const sessionOptions = [
    {id: 5, session: "Council 1-5"},
    {id: 6, session: "Council 1-6"},
];

const programOptions = [
    {id: 4, program: "Glosco"},
    {id: 8, program: "Global Research & Internship Program (GRIP)"},
];

const fieldValuesGrip = {
    ref_ids: '',
    ref_ids_array: [],
    program_ids: '',
    session_id: ''
};

const fieldUpdateGrip = [
    {colMd: "6", label: "Program", required: true, type: "multi-select", name: "program_ids", placeholderData: ["Select Programs"]},
    {colMd: "4", label: "Sessions", required: true, type: "select", name: "session_id", placeholderData: ["Select Session"]},
];

const fieldValidationGrip = {
    program_ids: 'required||Program',
    session_id: 'required||Sessions',
};

const fieldUpdateGripSA = [
    {colMd: "3", label: "Program", required: true, type: "multi-select", name: "program_ids", placeholderData: ["Select Programs"]},
    {colMd: "3", label: "Sessions", required: true, type: "select", name: "session_id", placeholderData: ["Select Session"]},
    {colMd: "6", label: "Ref Ids", required: true, type: "text", name: "ref_ids", placeholderData: ["Ids Separated by comma, Ex: 123,456,789"], readonly: true},
];

const fieldValidationGripSA = {
    program_ids: 'required||Program',
    session_id: 'required||Sessions',
    ref_ids: 'required||Ref Ids'
};

const fieldUpdateConf = [
    {colMd: "6", label: "Schools", required: true, type: "multi-select", name: "school_ids", placeholderData: ["Select Schools"]},
    {colMd: "6", label: "Session Name", required: true, type: "text", name: "session", placeholderData: ["Enter Session"]}
];

const fieldValuesConf = {
    school_ids: '',
    session: ''
};

const fieldValidationConf = {
    school_ids: 'required||Schools',
    session: 'required||Session Name'
};

export {
    masterTableFieldsGrip,
    sessionOptions,
    programOptions,
    fieldValuesGrip,
    fieldUpdateGrip,
    fieldValidationGrip,
    fieldUpdateGripSA,
    fieldValidationGripSA,
    masterTableFieldsConf,
    fieldUpdateConf,
    fieldValuesConf,
    fieldValidationConf
};